module.exports = function getResource(label) {
    let resources = { componentNotFound: 'Component not found' };
    return resources[label];
};
